import React, { useEffect, useState } from "react";
import { apiMethod } from "../../../api";
import BackupAccountUI from "./BackupAccountUI";

const GoogleDriveLink = () => {
  const [account, setAccount] = useState(null);
  const [unlinkModal, setUnlinkModal] = useState(null);
  const [unlinkLoading, setUnlinkLoading] = useState(false);

  useEffect(() => {
    getToken().then(getIdentity);
  }, [])

  const getToken = () => {
    return new Promise((resolve, reject) => {
      apiMethod("social_assign", {
        type: "gdriven"
      }, response => {
        if (response.access_token) {
          GDrive.token = response.access_token;
          resolve();
        }
      }, {
        errorCallback: (error) => { console.error(error) }
      })
    })

  }

  const getIdentity = () => {
    GDrive.getUserIdentity(userinfo => {
      setAccount(userinfo);
    }, () => {
      apiMethod('social_assign', { type: 'gdriven', dismiss: 'true' }, () => {
        GDrive.revoke_token();
      });
    });
  }

  const onLink = () => {
    GDrive.getTokenCallback((token, expire) => {
      HFN.message('Token saved.');
      getIdentity();
    });
  };

  const onUnlink = () => {
    apiMethod('social_assign', { type: 'gdriven', dismiss: 'true' }, ret => {
      GDrive.revoke_token();
      HFN.message(__('Account unlinked.'));
      setAccount(null);
    })
  }

  return (
    <BackupAccountUI
      type="gdrive"
      app={__("Google Drive Account")}
      account={account}
      linked={!!account}
      onLink={onLink}
      onUnlink={onUnlink}
      unavailable={true}
    />
  )
}

export default GoogleDriveLink;